<ng-container *ngIf="searchTerm$ | async as searchTerm">
  <!-- search result with products -->
  <ng-container *ngIf="(numberOfItems$ | async) || (filterParams$ | async); else noResult">
    <ish-search-result
      [searchTerm]="searchTerm"
      [totalItems]="numberOfItems$ | async"
      [deviceType]="deviceType$ | async"
    ></ish-search-result>
  </ng-container>

  <!-- empty search result -->
  <ng-template #noResult>
    <ish-search-no-result *ngIf="(searchLoading$ | async) === false" [searchTerm]="searchTerm"></ish-search-no-result>
  </ng-template>
</ng-container>
